import React, { useEffect, useState } from 'react';
import './Interactions.scss';

import TextComponent from './Text/Text';
import UrlComponent from './Url/Url';

const InteractionsComponent = (data) => {
  const [type, setType] = useState('');
  const [direction, setDirection] = useState('');

  useEffect(() => {
    if (data.interactionData.type) {
      setType(data.interactionData.type);
      setDirection('in');
    } else if (direction !== 'out') {
      setDirection('out');
      setTimeout(() => {
        setType(data.interactionData.type);
      }, 1000);
    }
  }, [data]);

  return (
    <div className='Interactions' style={{ height: `${data.height - 80}px` }}>
      {type === 'text' && <TextComponent data={data} direction={direction} />}
      {type === 'url' && <UrlComponent data={data} direction={direction} />}
    </div>
  );
};

export default InteractionsComponent;
